import type { Color } from "../types";
import type { ColorStringParser } from "./ColorStringParser";

/**
 * HEX color string parser. Parses color strings in hex format.
 * @example "#f00", "#00BB99", "#ff00ff77"
 */
export class HexColorStringParser implements ColorStringParser {
  /**
   * @inheritDoc
   */
  parse(colorString: string, quantumRange = 255): Color | undefined {
    if (/^#[a-f\d]{3}$/i.test(colorString)) {
      colorString =
        "#" +
        colorString
          .slice(1)
          .split("")
          .map((char) => char.repeat(2))
          .join("");
    }

    const match = colorString.match(
      /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i
    );

    if (!match) {
      return;
    }

    return [
      Math.round((parseInt(match[1], 16) / 255) * quantumRange),
      Math.round((parseInt(match[2], 16) / 255) * quantumRange),
      Math.round((parseInt(match[3], 16) / 255) * quantumRange),
      match[4]
        ? Math.round((parseInt(match[4], 16) / 255) * quantumRange)
        : quantumRange,
    ];
  }
}
